import { useLocation } from "react-router-dom";
import GonePage from "@/pages/GonePage";

/**
 * Iter270+307.4 — Guard global para caminhos tóxicos que a rota React normal
 * não consegue vetar de forma direta.
 *
 * Cobre famílias de URLs reportadas pelo Google Search Console (Jul/2026
 * e Fev/2026):
 *
 *   1. `/Users/**` — paths absolutos de estação de trabalho que vazaram
 *      via colagem de docx.
 *   2. Slugs `_pytest_` — episódios de teste automatizado que vazaram.
 *      Casam com `/episodio/:podcastSlug/:episodeSlug` (rota legítima),
 *      então precisam ser interceptados ANTES do <Routes> renderizar
 *      a EpisodePage e disparar chamadas de API 404.
 *   3. Prefixo `test-celebrate` em criador/autor — homologação vazada.
 *   4. `iter<N>-test<*>` — episódios/artigos de teste iterN.
 *   5. Podcast `test/*` — `/episodio/test/...` ou `/podcast/test`.
 *   6. `_wsod_recovery` — parâmetro/path interno de fallback SPA.
 *
 * Uso: renderize `<TestSlugGuard>{children}</TestSlugGuard>` no App.
 * Se o path bate, renderiza GonePage (com <meta robots noindex>) em
 * vez dos children.
 */
const TOXIC_PATH_PATTERNS = [
  /^\/Users\//i,
  /^\/home\/[^/]+\/(?:Downloads|Documents|Desktop)\//i,
  /^\/[Cc]:\//,
  /(^|\/)_pytest_/i,
  /(^|\/)test-celebrate/i,
  /(^|\/)test_celebrate/i,
  // Iter307.4 — novos padrões:
  /(^|\/)iter\d+[-_]test/i,       // ex.: iter240-test-2
  /^\/episodio\/test(?:\/|$)/i,   // podcast_slug === "test"
  /^\/podcast\/test(?:\/|$)/i,
  /(^|\/)_wsod(_recovery)?(\/|$|\?)/i,
];

export function isToxicPath(pathname) {
  if (!pathname) return false;
  return TOXIC_PATH_PATTERNS.some((rx) => rx.test(pathname));
}

export default function TestSlugGuard({ children }) {
  const { pathname } = useLocation();
  if (isToxicPath(pathname)) {
    return <GonePage />;
  }
  return children;
}
